/**
 * Устанавливает активную вкладку варианта размещения
 *
 * @param option вариант размещения
 * @param activeTab вкладка (0 — пакет, 1 — период)
 */
export const setOptionTab = (option, activeTab) => {
  option.activeTab = activeTab;
};
